/*
 * Blink mega menu - mobile drawer + drill-down navigation only.
 *
 * This is the "blink-" mega menu's copy of mega-menu.js, kept as its own
 * file so the original theme's menu system (menu.js, its jQuery drawer
 * relocation) stays untouched and can be switched back to at any time from
 * the theme editor - only one of the two systems is ever enabled at once.
 *
 * Deliberately does no layout work: desktop panels open/close purely via
 * CSS :hover/:focus-within, and each panel's column layout is already
 * resolved server-side in Liquid. This file only handles the mobile
 * off-canvas drawer and sliding between its "screens" (see
 * blink-mega-menu-mobile.liquid) - only one screen is ever visible at a
 * time, with a back button rather than an inline accordion.
 */
(function () {
  "use strict";

  function ready(fn) {
    if (document.readyState !== "loading") {
      fn();
    } else {
      document.addEventListener("DOMContentLoaded", fn);
    }
  }

  ready(function () {
    var drawer = document.querySelector("[data-mm-mobile-drawer]");
    var hamburger = document.querySelector("[data-mm-hamburger]");
    var stage = drawer && drawer.querySelector("[data-mm-mobile-stage]");

    if (!drawer || !hamburger || !stage) return;

    // The drawer is rendered inside header-mobile.liquid's markup, which
    // sits inside .section-header-mobile - an ancestor that creates its
    // own stacking context (position: relative + z-index in base.css).
    // A z-index on the drawer only ranks it within that ancestor's local
    // context, not the page as a whole, so it can end up visually behind
    // other elements regardless of how high the value is. Moving it to be
    // a direct child of <body> sidesteps that entirely.
    if (drawer.parentElement !== document.body) {
      document.body.appendChild(drawer);
    }

    function resetStage() {
      stage.querySelectorAll(".mm-mobile__screen").forEach(function (screen) {
        screen.classList.remove("is-active", "is-receded");
      });
      var root = stage.querySelector('.mm-mobile__screen[data-screen="root"]');
      if (root) {
        root.classList.add("is-active");
        root.scrollTop = 0;
      }
    }

    function openDrawer() {
      drawer.classList.add("is-open");
      drawer.setAttribute("aria-hidden", "false");
      hamburger.setAttribute("aria-expanded", "true");
      document.body.classList.add("mm-mobile-open");
      resetStage();
    }

    function closeDrawer() {
      drawer.classList.remove("is-open");
      drawer.setAttribute("aria-hidden", "true");
      hamburger.setAttribute("aria-expanded", "false");
      document.body.classList.remove("mm-mobile-open");
    }

    hamburger.addEventListener("click", function () {
      if (drawer.classList.contains("is-open")) {
        closeDrawer();
      } else {
        openDrawer();
      }
    });

    drawer.querySelectorAll("[data-mm-mobile-close]").forEach(function (el) {
      el.addEventListener("click", closeDrawer);
    });

    document.addEventListener("keydown", function (event) {
      if (event.key === "Escape" && drawer.classList.contains("is-open")) {
        closeDrawer();
      }
    });

    function showScreen(targetId, goingBack) {
      var current = stage.querySelector(".mm-mobile__screen.is-active");
      var target = stage.querySelector(
        '.mm-mobile__screen[data-screen="' + targetId + '"]',
      );
      if (!target || target === current) return;

      if (goingBack) {
        // Current screen retreats off to the right; the parent screen
        // (parked just off-stage to the left) slides back in from there.
        if (current) {
          current.classList.remove("is-active", "is-receded");
        }
        target.classList.remove("is-receded");
        target.classList.add("is-active");
      } else {
        // Current screen is parked just off-stage to the left as the new
        // (child) screen slides in from the right.
        if (current) {
          current.classList.remove("is-active");
          current.classList.add("is-receded");
        }
        target.classList.remove("is-receded");
        target.classList.add("is-active");
      }

      target.scrollTop = 0;
    }

    stage.querySelectorAll("[data-mm-drill]").forEach(function (button) {
      button.addEventListener("click", function () {
        showScreen(button.getAttribute("data-target-screen"), false);
      });
    });

    stage.querySelectorAll("[data-mm-back]").forEach(function (button) {
      button.addEventListener("click", function () {
        showScreen(button.getAttribute("data-target-screen"), true);
      });
    });
  });
})();
